import { render, staticRenderFns } from "./AskInno.vue?vue&type=template&id=96c0a566&scoped=true"
import script from "./AskInno.vue?vue&type=script&lang=js"
export * from "./AskInno.vue?vue&type=script&lang=js"
import style0 from "./AskInno.vue?vue&type=style&index=0&id=96c0a566&prod&lang=scss&scoped=true"
import style1 from "./AskInno.vue?vue&type=style&index=1&id=96c0a566&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96c0a566",
  null
  
)

export default component.exports